export default __webpack_public_path__ + "static/screenshot3-58ef79a112a1be6a14c5263d9e1d59e9.jpg";